module.exports = "static/assets/b55cb3190348cef7bf6bbf02f2e4ed24.png";